
import languageModel from "../../../models/language.model";

export default function ColumnValuesView() {
    return {
        view: (vnode) => {
            return [
                m('.row',
                    m('ul.list-group',
                        vnode.attrs.data.map(gc =>
                            [
                                m('li.list-group-item', gc)
                            ]),
                    )


                    // m(".table-responsive",
                    //     m("table.table",
                    //         [
                    //             m("thead.thead-bggrey",
                    //                 m("tr.align-middle",
                    //                     [
                    //                         m("th", { "scope": "col" }, languageModel.getText("LT00000xxx", "Key")),
                    //                         m("th", { "scope": "col" }, vnode.attrs.type)
                    //                     ])
                    //             ),
                    //             m("tbody",
                    //             vnode.attrs.data.map(gc =>
                    //                     [
                    //                         m("tr",
                    //                             [
                    //                                 m("td", "Key"),
                    //                                 m("td", gc)

                    //                             ])
                    //                     ]),
                    //             )
                    //         ])
                    // )

                )
            ]
        }
    }
}
